import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import AreasCreate from "./AreasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import QRCode from "react-qr-code";
import { jsPDF } from "jspdf";
import qrcode from "qrcode-js";

function ListadoAreas() {
  const { user } = useContext(AuthContext);
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [areas, setAreas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [esCaja, setEsCaja] = useState(false);
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  // Filtro activo / inactivo (default solo activos)
  const [filtroActivo, setFiltroActivo] = useState("Si");

  // Modal de QR
  const [modalQR, setModalQR] = useState(false);
  const toggleQR = () => setModalQR(!modalQR);
  const [qrId, setQrId] = useState("");
  const [qrName, setQrName] = useState("");

  function abrirQR(id, nombre) {
    setQrId(id);
    setQrName(nombre);
    toggleQR();
  }

  async function imprimirQR() {
    try {
      // Etiqueta fisica 150 x 100 mm (landscape). Layout compacto.
      const doc = new jsPDF("landscape", "mm", [150, 100], true);

      // Nombre del almacen: centrado, desplazado 10mm hacia abajo.
      doc.setFontSize(11).setFont(undefined, "bold");
      doc.text(`${qrName}`, 75, 16, { align: "center" });

      // QR 30x30mm centrado: x = (150-30)/2 = 60, y = 19.
      const base64 = await qrcode.toDataURL(qrId);
      const img = new Image();
      img.src = base64;
      doc.addImage(img, "png", 60, 19, 30, 30);

      // ID justo debajo del QR (sin gap grande).
      doc.setFontSize(6).setFont(undefined, "normal");
      const idLines = doc.splitTextToSize(`${qrId}`, 140);
      doc.text(idLines, 75, 53, { align: "center" });

      doc.output("dataurlnewwindow");
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editArea(event) {
    event.preventDefault();
    const URL_AREAS_EDIT = `${process.env.REACT_APP_URL_AREAS}/${idEdit}`;
    axios
      .patch(
        URL_AREAS_EDIT,
        {
          name,
          esCaja,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Area',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, esCaja) {
        setName(name);
        setEsCaja(!!esCaja);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_areas ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Almacenes</h3>
                    <div style={{ marginBottom: 10 }}>
                      <Label className="mr-sm-2">Estatus</Label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={filtroActivo}
                        onChange={(e) => setFiltroActivo(e.target.value)}
                      >
                        <option value="Si">Activos</option>
                        <option value="No">Inactivos</option>
                        <option value="">Todos</option>
                      </Input>
                    </div>
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Nombre</th>
                          <th className="tituloTabla">Es Caja</th>
                          <th className="tituloTabla">QR</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {areas
                          .filter(
                            (a) =>
                              filtroActivo === "" || a.is_active === filtroActivo
                          )
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            if (a._id != AREAS_GENERAL) {
                              return (
                                <tr>
                                  <td>{a.name}</td>
                                  <td>{a.esCaja ? "Si" : "No"}</td>
                                  <td>
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      onClick={() => abrirQR(a._id, a.name)}
                                    >
                                      <i class="fas fa-qrcode"></i>
                                    </Button>
                                  </td>
                                  <td>
                                    {
                                      a._id == AREAS_CEDIS?(
                                        <div>
                                        <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      disabled
                                      onClick={(e) => jalaInfo(a._id, a.name, a.esCaja)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>
                                      </div>
                                      ):(
                                        <div>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.name, a.esCaja)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_AREAS
                                      }
                                    />

                                    </div>
                                      )
                                    }                                   
                                   
                                  </td>
                                </tr>
                              );
                            }
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <AreasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Almacen</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Es Caja</Label>
          <Input
            className="col-sm-12"
            type="select"
            value={esCaja ? "Si" : "No"}
            onChange={(e) => setEsCaja(e.target.value === "Si")}
          >
            <option value="No">No</option>
            <option value="Si">Si</option>
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArea}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalQR} toggle={toggleQR}>
        <ModalHeader toggle={toggleQR}>QR Almacen</ModalHeader>
        <ModalBody>
          <div id="qr-print-area" style={{ textAlign: "center" }}>
            <h4 style={{ marginBottom: "16px" }}>{qrName}</h4>
            {qrId ? (
              <QRCode value={qrId} size={200} />
            ) : null}
            <p style={{ marginTop: "12px", fontSize: "10px", wordBreak: "break-all" }}>
              {qrId}
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={imprimirQR}>
            <i class="fas fa-print"></i> Imprimir
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoAreas;
